var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject } from "aurelia-framework";
var ManagePermissionsClientService = /** @class */ (function () {
    function ManagePermissionsClientService(requestClient) {
        this.requestClient = requestClient;
    }
    ManagePermissionsClientService.prototype.getAllPermissions = function (request) {
        return this.requestClient.get("permissions", request);
    };
    ManagePermissionsClientService.prototype.save = function (request) {
        return this.requestClient.post("permissions", {}, request);
    };
    ManagePermissionsClientService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [RequestClient])
    ], ManagePermissionsClientService);
    return ManagePermissionsClientService;
}());
export { ManagePermissionsClientService };
